import { render, staticRenderFns } from "./PoiCardSummary.vue?vue&type=template&id=2ee39727&"
import script from "./PoiCardSummary.vue?vue&type=script&lang=ts&"
export * from "./PoiCardSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports